import Cookies from 'js-cookie'
import { redirectStore } from '../util/redirectStore'
import { regions, COOKIE_DOMAIN, VISITOR_REGION_MAP, KEY_NAMES, BASE_REGION } from '../constants'

const getSelectedStore = () => {
  const selectedStoreCode = Cookies.get(KEY_NAMES.selectedStore)

  if (!regions[selectedStoreCode]) {
    Cookies.remove(KEY_NAMES.selectedStore, { domain: COOKIE_DOMAIN, path: '/' })
  }

  return regions[selectedStoreCode] || null
}

const getSuggestedStore = () => {
  const visitorCountryCode = localStorage.getItem(KEY_NAMES.visitorCountry)
  const suggestedStoreCode = VISITOR_REGION_MAP[visitorCountryCode]

  return regions[suggestedStoreCode] || regions[BASE_REGION]
}

export const storeRegionRedirect = () => {
  const selectedStore = getSelectedStore()
  const suggestedStore = getSuggestedStore()
  const currentStore = regions[REGION]
  const targetStore = selectedStore || suggestedStore

  if (targetStore.code !== currentStore.code) {
    // url suffix :  ?ref=CURRENTSTORE_store_redirect
    redirectStore(targetStore, currentStore, 'redirect')
  }
}
